module.exports = __webpack_public_path__ + "img/clear.df80f345.svg";